<style lang="less" scoped>
    .image-small {
        display: inline-block;
        width: 60px;
        height: 60px;
        overflow: hidden;
        img {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            max-width: 100%;
        }
        .download-btn{
            display: none;
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            text-align: center;
            background-color: rgba(55,55,55,.8);
            color: white;
            cursor: pointer;
        }
        &:hover .download-btn {
            display: inline-block;
            transition: .3s;
            &:hover {
                background-color: rgba(55,55,55,1);
            }
        }
    }
</style>
<template>
    <div>
        <Tooltip theme="light">
            <div class="image-small">
                <img :src="image_url" alt="" style="width: 60px">
                <div class="download-btn" @click="$util.forceDownload(image_url, filename)">
                    <Icon type="md-download" /> 下载
                </div>
            </div>
            <div slot="content">
                <img :src="image_url" alt="" style="max-width: 100%">
            </div>
        </Tooltip>
    </div>
</template>
<script>
    export default {
        props: {
            src: {
                type: String,
                required: true
            },
            filename: {
                type: String,
            }
        },
        data(){
            return {
                //
            }
        },
        computed: {
            cur_customer(){
                return this.$store.state.cur_customer;
            },
            image_url() {
                return this.$util.mallFileUrl(this.src);
            },
        },
        created(){
            //
        },
        mounted(){
            //
        },
        methods: {
            //
        }
    }
</script>
